import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=e71fb9e4&scoped=true"
import script from "./Next.vue?vue&type=script&lang=js"
export * from "./Next.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71fb9e4",
  null
  
)

export default component.exports